import { Heading } from 'yoso';
import { T } from '~/components/I18n';
import { levelMetaMap } from '~/components/Level/Level.hooks';
import { LevelUpGuideCard } from '~/components/LevelUp/Guide/LevelUpGuideCard';
import styles from './LevelUpGuide.module.scss';

const levelMetas = Object.values(levelMetaMap);

export const LevelUpGuide = () => (
  <div className={styles.root}>
    <Heading level={4} className={styles.heading}>
      <T name="citizen_levelup_require_title" />
    </Heading>
    <div className={styles.body}>
      {levelMetas.map(({ level }) => (
        <LevelUpGuideCard key={level} level={level} />
      ))}
    </div>
  </div>
);
